import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import app from 'flarum/forum/app';

export default class ShowOthersCssSettingsItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.checked = app.session.user.preferences()['kemze-user-css.showOthersCss'] !== false;
  }

  view() {
    return (
      <div className="Form-group KemzeUserCss-showOthersSetting">
        {Switch.component(
          {
            state: this.checked,
            onchange: (value) => this.save(value),
          },
          app.translator.trans('kemze-user-css.forum.settings.show_others_css_label')
        )}
        <div className="helpText">{app.translator.trans('kemze-user-css.forum.settings.show_others_css_help')}</div>
      </div>
    );
  }

  save(value) {
    // Flip immediately: this runs inside the switch's own event handler,
    // so Mithril redraws right after it returns and the toggle reflects
    // the change without needing a manual redraw call. On failure we
    // flip it back in the same way.
    const previous = this.checked;
    this.checked = value;

    app.session.user
      .savePreferences({ 'kemze-user-css.showOthersCss': value })
      .catch(() => {
        this.checked = previous;
        app.alerts.show({ type: 'error' }, app.translator.trans('kemze-user-css.forum.settings.show_others_css_failed'));
      })
  }
}
